import type { ExperimentDef } from "./types";

// FNV-1a hash for deterministic bucketing (32-bit)
function hash(str: string): number {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 16777619) >>> 0;
  }
  return h >>> 0;
}

export function bucket<V extends string>(exp: ExperimentDef<V>, visitorId: string): V {
  const seed = `${exp.name}:${visitorId}`;
  const slot = hash(seed) % 100;
  const n = exp.variants.length;
  const weights = exp.weights ?? exp.variants.map(() => 100 / n);
  let cum = 0;
  for (let i = 0; i < n; i++) {
    cum += weights[i];
    if (slot < cum) return exp.variants[i];
  }
  return exp.variants[n - 1];
}

type EventProps = Record<string, string>;

type WinExt = {
  plausible?: (name: string, opts?: { props?: EventProps }) => void;
  va?: { track?: (name: string, props?: EventProps) => void };
};

export function trackEvent(name: string, props?: EventProps): void {
  if (typeof window === "undefined") return;
  try {
    const w = window as unknown as WinExt;
    if (typeof w.plausible === "function") w.plausible(name, props ? { props } : undefined);
    if (w.va && typeof w.va.track === "function") w.va.track(name, props);
  } catch {
    /* noop */
  }
}

// Experiment registry. Keep variant[0] as control so visitors without storage
// see the existing copy.
export const experiments = {
  heroHeadline: {
    name: "hero_headline_v1",
    variants: ["control", "outcome"] as const,
  },
} as const;

export type HeroHeadlineVariant = (typeof experiments.heroHeadline.variants)[number];
